<template>
  <div class="event-modal-content">
    <span v-if="!inRegister">
      <h1 class="event-modal-content__title mb-2">{{ item.title }}</h1>
      <h6 class="font-italic">
        <div
          class="point-information"
          :data-point="item.type"
          style="display: inline-flex; margin-right: .2rem;"
        ></div>
        {{ item.display_type }} con {{ item.mentor }} el {{ getHumanDateOfTimestamp(item.timestamp) }}
      </h6>
      <br />
      <p class="event-modal-content__description">{{ item.description }}</p>

      <span v-if="item.requirements">
        <h6 style="font-weight: 400 !important;">Requisitos</h6>
        <p>{{ item.requirements }}</p>
      </span>

      <div class="d-flex">
        <button class="btn btn-primary" @click="inRegister = true">Inscríbete</button>
      </div>
    </span>

    <span v-if="inRegister" transition="expand">
      <RegisterToEvent
        :status="statusForm"
        :msg="message"
        @submit="onSubmit(item.id, $event)"
        submitText="Registrarme"
      />

      <p @click="onCancel" class="cancel-register">
        <span v-if="statusForm === 'progress'" @click="onCancel">Cancelar</span>
        <span v-if="statusForm === 'warning'" @click="onCancel">Regresar</span>
        <span v-if="statusForm === 'success'" @click="onCancel">Volver</span>
      </p>
    </span>
  </div>
</template>

<script>
import { getHumanDateOfTimestamp } from "../helpers";
import RegisterToEvent from "./RegisterToEvent.vue";

export default {
  components: {
    RegisterToEvent
  },
  props: {
    item: Object
  },
  data() {
    return {
      statusForm: "progress",
      inRegister: false,
      message: ""
    };
  },
  created() {
    this.inRegister = false;
  },
  methods: {
    getHumanDateOfTimestamp,
    onSubmit(id, value) {
      value.eventid = id;
      const url = process.env.VUE_APP_ROOT_API + "/slothtech-events";
      (async () => {
        this.statusForm = "sending";
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Api-Key": process.env.VUE_APP_API_KEY
          },
          body: JSON.stringify(value)
        });
        const content = await response.json();
        this.message = content.message;
        this.statusForm = content && content.success ? "success" : "warning";
      })();
    },
    openRegister() {
      this.statusForm = "progress";
    },
    onCancel() {
      this.inRegister = false;
      this.statusForm = "progress";
    }
  }
};
</script>
